// extracted by mini-css-extract-plugin
export default {"title":"TabTre_title__wadl4","textFieldDisabled":"TabTre_textFieldDisabled__AF+73"};